import React, { useState } from "react";
import { makeThemedStyles } from "./../../viewcomponents/utils";
import clsx from "clsx";
import { useAppContext } from "./../../context/AppCtxProvider";
import * as registry from "@qpr/client-api-registry";
type IResizewrapper = {
  children: JSX.Element | JSX.Element[];
};
type IContentwrapper = {
  children: JSX.Element | JSX.Element[];
  fullWidth: boolean;
};
const useStyles = makeThemedStyles("", (theme) => ({
  ResizeWrapper: {
    width: "100%",
    display: "flex",
  },
  LeftWrapper: {
    width: "60%",
    transition: "width 0.5s",
  },
  RightWrapper: {
    width: "40%",
    position: "relative",
    transition: "width 0.5s",
  },
  SplitContainer: {
    width: "25px",
    height: "25px",
    position: "absolute",
    top: "60vh",
    left: "-16px",
    zIndex: 9999,
  },
  fullWidth: {
    width: "50%",
  },
  Right: {
    right: "-16px",
  },
}));
const ResizeWrapper = ({ children }: IResizewrapper) => {
  const classes = useStyles();
  return <div className={classes.ResizeWrapper}>{children}</div>;
};
export const LeftWrapper = ({ children, fullWidth }: IContentwrapper) => {
  const classes = useStyles();
  return (
    <div className={clsx(classes.LeftWrapper, fullWidth && classes.fullWidth)}>
      {children}
    </div>
  );
};
export const RightWrapper = ({
  children,
  fullWidth,
  setWidth,
}: IContentwrapper & {
  setWidth: (isFull: boolean) => void;
}) => {
  const classes = useStyles();
  const currentState = !!localStorage.getItem("fullWidth");
  const [full, setFullWidth] = useState<boolean>(currentState);
  const ctx = useAppContext();
  const { rtl } = ctx;
  const Resize = registry.getSvg("Resize");
  const onClickSplit = () => {
    setWidth(!full);
    setFullWidth(!full);
    const expanded = full ? "" : "true";
    localStorage.setItem("fullWidth", expanded);
  };
  return (
    <div className={clsx(classes.RightWrapper, fullWidth && classes.fullWidth)}>
      <div className={clsx(classes.SplitContainer, rtl && classes.Right)}>
        <Resize onClick={onClickSplit} />
      </div>
      <div>{children}</div>
    </div>
  );
};
export default ResizeWrapper;
